<template>
  <span class="select-search-container">
  <i
      :id="field + '-search-icon'"
      class="fa fa-search select-search-icon"
      :data-input-id="field + '-search-item'"
      :data-list-id="field + '-search-list'"
      :data-select-id="field"
      @click="searchFilterFieldClick($event);"> </i>
  <input
      :list="field + '-search-list'"
      :id="field + '-search-item'"
      autocomplete="off"
      class="select-search-input"
      :data-icon-id="field + '-search-icon'"
      @change="searchFilterFieldInputChange($event)"/>
  <datalist :id="field + '-search-list'"></datalist>
  </span>
</template>

<script>

export default {
  name: 'SelectSearch',
  components: {},
  props: {
    handlerFunc: {
      type: Function,
      required: true
    },
    field: String,
    options: Object,
  },
  data() {
    return {
    }
  },
  methods: {
    searchFilterFieldClick(event) {
      let inputItem, listItem, selectItem;
      if (event) {
        inputItem = document.getElementById(event.target.getAttribute("data-input-id"));
        listItem = document.getElementById(event.target.getAttribute("data-list-id"));
        selectItem = document.getElementById(event.target.getAttribute("data-select-id"));
        if (!inputItem) {
          console.log("not found DOM elements for search: inputItem")
          return;
        }
        if (!listItem) {
          console.log("not found DOM elements for search: listItem")
          return;
        }
        if (!selectItem) {
          console.log("not found DOM elements for search: selectItem")
          return;
        }
        if (event.target.className.includes("fa-times")) {
          inputItem.style.display = "none";
          event.target.className = event.target.className.replace("fa-times", "fa-search");
          return;
        }
        event.target.className = event.target.className.replace("fa-search", "fa-times");
      } else {
        return;
      }
      listItem.innerHTML = '';
      for (let optionIndex in this.options) {
        let opt = document.createElement("option");
        if (this.options[optionIndex].label !== this.options[optionIndex].value) {
          opt.setAttribute("value", this.options[optionIndex].value);
          opt.textContent = this.options[optionIndex].label;
        } else {
          opt.textContent = this.options[optionIndex].label;
        }
        listItem.append(opt);
      }
      inputItem.value = "";
      inputItem.style.width = selectItem.offsetWidth - 45 + "px";
      inputItem.style.display = "inherit";
      inputItem.focus();
    },
    searchFilterFieldInputChange(event) {
      let iconItem;
      if (event) {
        let newVal =  event.target.value;
        event.target.style.display = "none";
        this.handlerFunc(newVal, this.field);
        iconItem = document.getElementById(event.target.getAttribute("data-icon-id"))
      } else {
        return;
      }
      iconItem.className = iconItem.className.replace("fa-times", "fa-search");
    },
  },
}
</script>

<style>

i.fa.select-search-icon {
  display: inline;
  float: right;
  position: absolute;
  top: 11px;
  right: 28px;
  cursor: pointer;
  opacity: 0.5;
}
input.select-search-input {
  display: none;
}
input.select-search-input, input.select-search-input:focus, input.select-search-input:focus-visible {
  border: none;
  position: absolute;
  left: 8px;
  /*background: #fff0;*/
  top: 4px;
}
</style>